import React from 'react';
import PropTypes from 'prop-types';

import { BRAND_LIBRARY_BODY_TEXT } from 'common/constants/brandLibrary';
import Paragraph from 'common/components/TouchpointEditor/components/TouchpointNodes/Paragraph';
import useDynamicTags from 'common/components/TouchpointEditor/hooks/useDynamicTags';

export default function TextParagraph(props) {
    const content = useDynamicTags(props.meta.content);

    return <Paragraph {...props} meta={{ ...props.meta, content }} />;
}

TextParagraph.propTypes = {
    meta: PropTypes.shape({
        content: PropTypes.string.isRequired,
    }).isRequired,
};

TextParagraph.splash = {
    ...Paragraph.splash,
    defaultProps: {
        ...Paragraph.splash.defaultProps,
        styles: {
            ...Paragraph.splash.defaultProps.styles,
            fontFamily: BRAND_LIBRARY_BODY_TEXT,
            fontSize: 16,
        },
        meta: {
            ...Paragraph.splash.defaultProps.meta,
            // eslint-disable-next-line max-len
            content:
                'Welcome! Event check-in opens [event_date][start_time]. Click the event page link below for more details.',
        },
    },
};
